<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Leads list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewLeads()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="status-box item">
            <label for="paginate" class="mb-0">VSA User</label>
            <select
              v-model="selectedBDM"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All</option>
              <option
                v-for="item in getDealerStaffDropdown"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="ref-partner-box item">
            <label for="paginate" class="mb-0">Referral partner</label>
            <select
              v-model="referralPartnerId"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All</option>
              <option
                v-for="item in getReferralPartnerDropdownList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="status-box item">
            <div>
              <label for="paginate" class="mb-0">Status</label>
              <select
                v-model="selectedStatus"
                class="form-control sits_select"
                @change="fnSearch()"
              >
                <option value="">All</option>
                <option
                  v-for="item in optionLeadsAndQuoteStatus"
                  :value="item.value"
                  :key="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0">From</label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="fromDate"
            ></datePicker>
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0">To</label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="toDate"
            ></datePicker>
          </div>

          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnExport()">
              Export <b-spinner small v-if="isExporting"></b-spinner>
            </button>
          </div>

          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableLeadsList">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item header-column-0"></th>
                <th class="header-item header-column-1 v-th-80">
                  <a href="#" @click.prevent="fnChangeSort('id')">Leads Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-2 v-th-80">Quote Id</th>
                <th class="header-item header-column-3">Source</th>

                <th class="header-item header-column-4">Referral</th>
                <th class="header-item header-column-5">Source URL</th>
                <th class="header-item header-column-6">Client Name</th>
                <th class="header-item header-column-7">Phone</th>
                <th class="header-item header-column-8">Make</th>
                <th class="header-item header-column-9">Model</th>

                <th class="header-item header-column-10 v-th-90">
                  <a href="#" @click.prevent="fnChangeSort('created_at')"
                    >Created</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'created_at'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'created_at'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-11 v-th-90">
                  Next followup
                </th>
                <th class="header-item header-column-12">BDM/Sent by</th>
                <th class="header-item header-column-13 v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>

                <th class="header-item header-column-14 v-th-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(quote, index) in getAdminLeadsPaginateData.data"
              >
                <tr :key="(quote, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span
                      class="pl-2"
                      :class="{
                        'is-leads-nots-exist':
                          fnCheckLeadsNoteExist(quote.leadsNote) == true,
                        'no-leads-nots-exist':
                          fnCheckLeadsNoteExist(quote.leadsNote) == false
                      }"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td class="column-0">{{ quote.id }}</td>
                  <td class="column-0">{{ quote.id_quote }}</td>
                  <td class="column-0">{{ quote.leadSource }}</td>

                  <td class="column-1">
                    <span v-if="quote.leadSource != 'RDL'">{{
                      quote.rp_name
                    }}</span
                    ><span v-if="quote.leadSource == 'RDL'">{{
                      quote.refer_dealer_name
                    }}</span>
                  </td>
                  <td class="column-1">
                    <WDExpandDetailCell
                      :rowId="quote.id"
                      :content="quote.sourceUrl"
                      @fnSelectRow="fnSetActiveRow(quote.id)"
                      @fnCloseExpand="fnCloseExpand"
                      :activeRow="activeRow"
                      :numberOfCharLimit="15"
                    ></WDExpandDetailCell>
                  </td>
                  <td class="column-2">
                    <span
                      >{{ quote.client_first_name }}
                      {{ quote.client_last_name }} |
                      <span class="text-black-60 fs-600">
                        {{ quote.hAddressState }}</span
                      ></span
                    >
                    <br />
                    <span class="text-black-60 fs-600">{{
                      quote.employerName
                    }}</span>
                  </td>
                  <td class="column-4">
                    {{ quote.client_mobile_number }}
                  </td>
                  <td class="column-4">
                    {{ quote.make }}
                  </td>
                  <td class="column-4">
                    {{ quote.model }}
                  </td>
                  <td class="column-5">
                    <span v-if="quote.created_at != null">{{
                      quote.created_at | dateConvertDDMMYYYY
                    }}</span>
                    <span v-else></span>
                  </td>

                  <td class="column-6">
                    <span v-if="quote.nextFollowupDate != null">{{
                      quote.nextFollowupDate | dateConvertDDMMYYYY
                    }}</span>
                    <span v-else></span>
                  </td>

                  <td class="column-0">
                    <span v-if="quote.createdBy && quote.createdBy">{{
                      quote.createdBy
                    }}</span
                    ><span v-else></span>
                  </td>

                  <td class="column-7">
                    <div v-if="quote.status_quote != ''">
                      <WDQuoteStatusBadge
                        :status="quote.status_quote"
                      ></WDQuoteStatusBadge>
                    </div>
                    <div v-else>
                      <WDLeadsStatusBadge
                        :status="quote.status"
                      ></WDLeadsStatusBadge>
                    </div>
                  </td>

                  <td class="column-8">
                    <div class="d-flex">
                      <div>
                        <span v-if="quote.status != 21">
                          <a
                            @click="fnGoViewQuote(quote.id)"
                            v-b-tooltip.hover
                            title="View quote"
                            class="d-inline pr-2"
                            ><i class="far fa-eye text-primary fs-1000"></i
                          ></a>
                        </span>
                        <span v-else>
                          <i
                            class="
                              las
                              la-hand-paper
                              d-inline
                              pr-2
                              text-primary
                              fs-1200
                            "
                          ></i>
                        </span>
                      </div>
                      <div>
                        <a
                          v-if="quote.status != 23"
                          @click="fnGoEditQuote(quote.id)"
                          v-b-tooltip.hover
                          title="Update quote"
                          class="d-inline pr-2"
                          ><i class="far fa-edit text-primary fs-1000"></i
                        ></a>
                        <i
                          v-else
                          class="
                            las
                            la-hand-paper
                            d-inline
                            pr-2
                            text-primary
                            fs-1200
                          "
                        ></i>
                      </div>

                      <appModalNextFollowup
                        v-if="quote.status != 29"
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      ></appModalNextFollowup>

                      <appModalLeadsMsgVSA
                        v-if="quote.status != 29"
                        :quoteId="quote.id"
                        :quote="quote"
                        class="d-inline pr-2"
                      ></appModalLeadsMsgVSA>

                      <modalLeadsStatusUpdate
                        :row="quote"
                        @fnRefresh="fnReload()"
                        class="d-inline pr-2"
                      ></modalLeadsStatusUpdate>
                      <appModalLeadsArchive
                        v-if="quote.status != 29"
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      >
                      </appModalLeadsArchive>

                      <appModalLeadsTransfer
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      ></appModalLeadsTransfer>
                    </div>
                  </td>
                </tr>
                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="15">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-6 col-md-6 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Updated</dt>
                          <dd class="col-sm-7">
                            <span v-if="quote.updated_at != null">{{
                              quote.updated_at | dateConvertDDMMYYYYTime
                            }}</span>
                            <span v-else></span>
                          </dd>
                          <dt class="col-sm-5">Email</dt>
                          <dd class="col-sm-7">
                            {{ quote.client_email }}
                          </dd>
                          <dt class="col-sm-5">Pricing Document</dt>
                          <dd class="col-sm-7" v-if="quote.pricingDocumentUrl">
                            <a
                              class="text-primary fw-600"
                              :href="quote.pricingDocumentUrl"
                              target="_blank"
                              >View document</a
                            >
                          </dd>
                        </dl>
                        <!-- List of  application notes-->
                        <dl class="row" v-if="quote && quote.notes">
                          <dt class="col-sm-12">Application Notes</dt>
                          <dd class="col-sm-12">
                            <div>
                              <b-card-text
                                v-html="quote.notes.applicationNotes"
                              ></b-card-text>
                            </div>
                          </dd>
                        </dl>
                      </div>

                      <div class="col-lg-6 col-md-6 col-12">
                        <!-- List of Leads Notes -->
                        <WDVsaLeadsNotes
                          v-if="quote.leadsNote.length"
                          :leadsNote="quote.leadsNote"
                        ></WDVsaLeadsNotes>

                        <!-- VSA quotes and leads logs -->
                        <WDVsaQuoteLeadsLogs
                          v-if="quote.vsa_logs.length"
                          :vsaLogs="quote.vsa_logs"
                        ></WDVsaQuoteLeadsLogs>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="15">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getAdminLeadsPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '../../../store/modules/base.module'
import { optionLeadsAndQuoteStatus } from '../../../services/data.service'
import pagination from 'laravel-vue-pagination'
import * as leadsService from '../../../services/leads.service'
import * as taxTableService from '../../../services/taxTable.service'
import * as quoteCalculationService from '../../../services/quoteCalculation.service'
import appModalLeadsMsgVSA from '../../../components/leads/ModalLeadsMsgVSA.vue'
import appModalLeadsArchive from '../../../components/leads/ModalLeadsArchive.vue'
import appModalNextFollowup from '../../../components/leads/ModalNextFollowup.vue'
import appModalLeadsTransfer from '../../../components/admin/ModalLeadsTransfer.vue'
import WDLeadsStatusBadge from '../../../components/wd/WDLeadsStatusBadge.vue'
import WDQuoteStatusBadge from '../../../components/wd/WDQuoteStatusBadge.vue'
import WDVsaQuoteLeadsLogs from '../../../components/wd/WDVsaQuoteLeadsLogs.vue'
import WDVsaLeadsNotes from '../../../components/wd/WDVsaLeadsNotes.vue'
import WDExpandDetailCell from '../../../components/wd/WDExpandDetailCell.vue'
import modalLeadsStatusUpdate from '../../../components/admin/ModalLeadsStatusUpdate.vue'
import datePicker from 'vue2-datepicker'

export default {
  name: 'adminLeadsList',
  components: {
    pagination,
    datePicker,
    appModalLeadsMsgVSA,
    appModalLeadsArchive,
    appModalNextFollowup,
    appModalLeadsTransfer,
    modalLeadsStatusUpdate,
    WDLeadsStatusBadge,
    WDQuoteStatusBadge,
    WDVsaQuoteLeadsLogs,
    WDVsaLeadsNotes,
    WDExpandDetailCell
  },
  data() {
    return {
      isDataFetch: true,
      opened: [],
      activeRow: -1,
      isExporting: false,
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedBDM: '',
      selectedStatus: '',
      fromDate: '',
      toDate: '',
      sort_direction: 'desc',
      sort_field: 'id',
      quoteCalculation: {},
      optionLeadsAndQuoteStatus: optionLeadsAndQuoteStatus,
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedBDM: '',
        selectedStatus: '',
        referralPartnerId: '',
        fromDate: '',
        toDate: '',
        sort_direction: 'desc',
        sort_field: 'id'
      },
      referralPartnerId: ''
    }
  },
  computed: {
    ...mapGetters([
      'getLeadsSingle',
      'getAdminLeadsPaginateData',
      'getAdminLeadsPaginate',
      'getReferralPartnerDropdownList',
      'getDealerStaffDropdown'
    ])
  },
  methods: {
    ...mapActions([
      'fetchLeadsSingle',
      'fetchAdminLeadsPaginate',
      'fetchReferralPartnerDropdownList',
      'fetchDealerStaffDropdown'
    ]),

    fnGoNewLeads() {
      this.$router.push({ name: 'admin.LeadsNew' })
    },

    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGoViewQuote(id) {
      this.$router.push({
        name: 'admin.leadsView',
        params: { quoteId: id }
      })
    },
    fnGoEditQuote(id) {
      this.$router.push({ name: 'admin.leadsEdit', params: { quoteId: id } })
    },

    // Quote calculation to send some data into download excel
    fnQuoteCalculation(quoteType, quoteId, quoteSingle) {
      return quoteCalculationService.calculation1(
        quoteType,
        quoteId,
        quoteSingle
      )
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        referralPartnerId: this.referralPartnerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        referralPartnerId: this.referralPartnerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchAdminLeadsPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        referralPartnerId: this.referralPartnerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        referralPartnerId: this.referralPartnerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      this.fromDate = ''
      this.toDate = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedBDM: this.selectedBDM,
        selectedStatus: '',
        referralPartnerId: '',
        fromDate: '',
        toDate: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    },
    fnCheckLeadsNoteExist(obj) {
      if (obj.length > 0) {
        return true
      }
      return false
    },
    /**
     * Export Leads List into excel file and download
     */
    fnExport: async function () {
      this.isExporting = true
      let obj2 = {
        q: this.q,
        selectedBDM: this.selectedBDM,
        selectedStatus: this.selectedStatus,
        referralPartnerId: this.referralPartnerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj2 }

      const filePath = await leadsService.createLeadsListExport(objNew)

      //file name and path of the finance doc.
      let obj3 = {
        file_name: filePath.data
      }

      // Download from Export Leads List in temp folder
      window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

      // Delete Export Leads List in temp folder
      await leadsService.deleteTempLeadsListExport(obj3)

      this.isExporting = false
    },

    /**
     * After update Leads status need to call fnGetQuoteList
     * For Refresh data in listing
     */
    fnReload() {
      this.fnGetQuoteList()
    },

    fnSetActiveRow(rowId) {
      this.activeRow = rowId
      return
    },
    fnCloseExpand() {
      this.activeRow = -1
      return
    }
  },
  created() {
    this.fetchDealerStaffDropdown(73)
    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },
  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedBDM: '',
      selectedStatus: '',
      referralPartnerId: '',
      fromDate: '',
      toDate: '',
      sort_direction: 'desc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchAdminLeadsPaginate(objNew)
    await this.fetchReferralPartnerDropdownList('a')
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 350px;
  }
  .ref-partner-box {
    width: 250px;
  }
  .status-box {
    width: 150px;
  }
  .date-box {
    width: 130px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}

.is-leads-nots-exist {
  color: var(--iq-color10) !important;
}
.no-leads-nots-exist {
  color: var(--iq-info) !important;
}
</style>
